import React from 'react'
import Link from 'gatsby-link'
import NextStaticPage from '../components/Linking/nextStaticPage'
import SocialIcon from '../components/Social/socialIcon'
import {Helmet} from "react-helmet";


const About = () => (
  <article className="static-page">
  <Helmet>
       <meta name="robots" content="noindex, follow" />      
   </Helmet>
    <h2>Hola!</h2>
    <p>Mi nombre es Gorka (también conocido como <i>@gmugart</i>). Diseño y desarrollo soluciones digitales desde Bilbao.
Los últimos años he trabajado en Reino Unido, en proyectos web y email para marcas nacionales e internacionales.
    </p>
    <p>Cuando no estoy leyendo sobre diseño, programación o emprendizaje disfruto viajando, surfeando o tomando un buen <del>afternoon tea</del> café. </p>
    <p>En este sitio comparto contigo lo aprendido por el camino y lo que está por llegar. Si estás interesado en el el diseño UI/UX o el desarrollo web no dudes en suscribirte a la <Link to="/portfolio">newsletter</Link>.
      
    </p>

    <h3>Dónde puedes encontrarme</h3>
 

        <SocialIcon  size="2x" style={{position:"relative", top:"-2px", width:"300px"}} link="https://www.linkedin.com/in/gorka-muñoz" iconName="linkedin-in" title="LinkedIn" ariaLabel="LinkedIn social icon"/> 
        <SocialIcon size="2x" link="https://twitter.com/gmugart" iconName="twitter" title="Twitter" ariaLabel="Twitter social icon"/> 
        <SocialIcon  size="2x" link="https://codepen.io/gmugart/" iconName="codepen" title="Codepen" ariaLabel="Codepen social icon"/> 
        <SocialIcon  size="2x" link="https://www.behance.net/gmugart" iconName="behance" title="Behance" ariaLabel="Behance social icon"/> 
        
    

    {/*<p>
También puedes ponerte en contacto conmigo mandando un email a <a href="mailto:info@gmugart.com">
    info@gmugart.com</a></p>*/}
 
    <NextStaticPage to="portfolio" text="Visita mi portfolio"/>
    
  </article>
)

export default About



// WEBPACK FOOTER //
// ./src/pages/sobre-mi.js